import React, { useEffect, useRef } from 'react';
import { partners } from '../../data/partners';
import { useCarousel } from '../../hooks/useCarousel';

const PartnersCarousel = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { startCarousel, stopCarousel } = useCarousel(containerRef);

  useEffect(() => {
    startCarousel();
    return () => stopCarousel();
  }, [startCarousel, stopCarousel]);

  return (
    <div className="overflow-hidden mt-12">
      <div 
        ref={containerRef}
        className="flex items-center space-x-16 animate-scroll"
      >
        {[...partners, ...partners].map((partner, index) => (
          <div 
            key={`${partner.name}-${index}`}
            className="flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300"
          >
            <img
              src={partner.logo}
              alt={partner.name}
              className="h-12 w-auto object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnersCarousel;